/* ShopKitchens 31oct fix layer — collection cards, direct add, Pro workspace, PDP label guard.
   Uses only real store data (product .js JSON, saved palette, resolved variant ids). No invented prices. */
(function () {
  'use strict';
  var money = function (c) { return new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format((Number(c) || 0) / 100); };
  function isCabinet(card) {
    var chip = card.querySelector('.skz-profile-chip, .k4l-profile-chip');
    var title = card.querySelector('.card__heading a');
    return !!chip || (title && /cabinet/i.test(title.textContent || ''));
  }
  function setBtnLabel(btn, label) {
    if (!btn) return;
    var spans = Array.prototype.slice.call(btn.querySelectorAll(':scope > span')).filter(function (s) {
      return !s.classList.contains('loading__spinner') && !s.classList.contains('icon-wrap') && !s.classList.contains('sold-out-message');
    });
    /* Guard: never rewrite identical text. The collection MutationObserver
       below watches this subtree, and an unconditional textContent assignment
       replaces the text node on every scan, re-triggering the observer
       forever (a microtask thrash that starves rendering/scroll/navigation).
       Only write when the label actually changes. */
    if (spans[0]) { if (spans[0].textContent !== label) spans[0].textContent = label; }
    else {
      var t = Array.prototype.slice.call(btn.childNodes).find(function (n) { return n.nodeType === 3 && n.textContent.trim(); });
      if (t && t.textContent.trim() !== label) t.textContent = ' ' + label + ' ';
    }
  }
  function resolvedId(card) { return card.dataset.skzVariantId || ''; }
  function onePrice(card) {
    if (card.querySelector('.skv-card-meta .skv-card-price__top strong')) card.classList.add('sk-one-price');
  }
  function relabel(card) {
    var id = resolvedId(card);
    if (!id) return;
    var btn = card.querySelector('.quick-add__submit');
    if (btn && !btn.disabled) setBtnLabel(btn, isCabinet(card) ? 'Add to Kitchen' : 'Add');
  }
  var cache = {};
  function fetchProduct(handle) {
    if (!cache[handle]) cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); });
    return cache[handle];
  }
  function fixSalePrice(card) {
    var priceEl = card.querySelector('.card-information > .price');
    if (!priceEl || !priceEl.classList.contains('price--on-sale')) return;
    var id = resolvedId(card);
    if (!id) return;
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return;
    var m = new URL(a.href, location.origin).pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    fetchProduct(decodeURIComponent(m[1])).then(function (p) {
      var v = (p.variants || []).find(function (x) { return String(x.id) === String(id); });
      if (!v) return;
      card.querySelectorAll('.price .price-item--sale, .price .price-item--regular').forEach(function (el) { var p = money(v.price); if (el.textContent !== p) el.textContent = p; });
    }).catch(function () {});
  }
  function scanCards() {
    document.querySelectorAll('#ProductGridContainer .card-wrapper, main[data-template="search"] .card-wrapper').forEach(function (card) {
      onePrice(card); relabel(card); fixSalePrice(card);
    });
  }
  function profile() { try { return window.ShopKitchensProfile && window.ShopKitchensProfile.get ? window.ShopKitchensProfile.get() : null; } catch (e) { return null; } }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.card-wrapper .quick-add__submit');
    if (!btn) return;
    var card = btn.closest('.card-wrapper');
    var id = card && resolvedId(card);
    if (!card || !id) return; /* no resolved variant: let the Choose-options dialog open normally */
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (btn.dataset.skAdding === '1') return;
    btn.dataset.skAdding = '1'; btn.disabled = true; setBtnLabel(btn, 'Adding…');
    var prof = profile();
    var fd = new FormData(); fd.append('id', id); fd.append('quantity', '1');
    if (prof) {
      if (prof.activeLookName) fd.append('properties[Kitchen Look]', prof.activeLookName);
      if (prof.finish) fd.append('properties[Kitchen Finish]', prof.finish);
      if (prof.box) fd.append('properties[Cabinet Box]', prof.box);
    }
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && cart.getSectionsToRender) {
      try { fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; })); fd.append('sections_url', location.pathname); } catch (err) {}
    }
    var cfg = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/json' } };
    cfg.headers = cfg.headers || {}; cfg.headers['X-Requested-With'] = 'XMLHttpRequest'; delete cfg.headers['Content-Type']; cfg.body = fd;
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', cfg).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || res.message || 'Unable to add');
      setBtnLabel(btn, 'Added ✓');
      if (cart && cart.renderContents) { try { cart.renderContents(res); } catch (err) { location.assign('/cart'); } }
      else location.assign('/cart');
    }).catch(function () { setBtnLabel(btn, 'Try again'); }).finally(function () {
      btn.disabled = false; delete btn.dataset.skAdding;
      setTimeout(function () { if (resolvedId(card)) setBtnLabel(btn, isCabinet(card) ? 'Add to Kitchen' : 'Add'); }, 1200);
    });
  }, true);

  /* Palette fallback: saved Kitchen Palette first, then collection URL params
     (style_name/box_type, injected by the style controller), then legacy keys.
     This is what makes collection direct-Add and PDP initial variant work even
     when no localStorage palette was ever saved. */
  function palette() {
    var prof = profile();
    if (prof && prof.finish && prof.box) return prof;
    try {
      var q = new URLSearchParams(location.search);
      var f = q.get('style_name'), b = q.get('box_type');
      if (f && b) return { finish: f, box: b, activeLookName: 'Main Kitchen' };
      var lf = localStorage.getItem('skzCabinetStyle'), lb = localStorage.getItem('skzCabinetBox');
      if (lf && lb) return { finish: lf, box: lb, activeLookName: 'Main Kitchen' };
    } catch (e) {}
    return prof;
  }
  function normOpt(v) { return String(v || '').toLowerCase().replace(/3\/4|¾/g, '').replace(/&/g, 'and').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function resolveVariant(prod, pal) {
    if (!prod || !pal || !pal.finish || !pal.box) return null;
    var opts = (prod.options || []).map(function (o) { return typeof o === 'string' ? o : (o.name || ''); });
    var fi = -1, bi = -1;
    opts.forEach(function (n, i) { if (/door style|door finish|^finish$/i.test(n)) fi = i; if (/box material|cabinet box/i.test(n)) bi = i; });
    if (fi < 0 && bi < 0) return null;
    var avail = (prod.variants || []).filter(function (v) { return v.available !== false; });
    return avail.find(function (v) { return (fi < 0 || normOpt(v.options[fi]) === normOpt(pal.finish)) && (bi < 0 || normOpt(v.options[bi]) === normOpt(pal.box)); }) || null;
  }
  /* PDP: on a fresh product load, if the URL has no variant (or a different one)
     and a palette is known, replace the URL once with the palette variant.
     Guarded: only when the current form id and the URL variant both differ
     from the target, so this can never loop. Non-cabinet products: no-op. */
  var skPdpPaletteDone = false;
  function applyPdpPalette() {
    if (skPdpPaletteDone) return;
    var info = document.querySelector('main product-info[data-url]');
    if (!info) return;
    var pal = palette(); if (!pal) return;
    var path = (info.dataset.url || '').split('?')[0]; if (!path) return;
    var curFormId = (info.querySelector('form[data-type="add-to-cart-form"] [name="id"]') || {}).value || '';
    var curUrlId = new URLSearchParams(location.search).get('variant') || '';
    fetchProduct(path.replace(/^\/products\//, '')).then(function (prod) {
      var v = resolveVariant(prod, pal); if (!v) return;
      if (String(curFormId) === String(v.id) || String(curUrlId) === String(v.id)) return;
      skPdpPaletteDone = true;
      var u = new URL(location.href); u.searchParams.set('variant', v.id); u.searchParams.delete('style_name'); u.searchParams.delete('box_type');
      location.replace(u.toString());
    }).catch(function () {});
  }
  /* Collection fallback resolver: if the cabinet-shop script has not resolved
     a card (no dataset variant id), resolve it here from the palette and the
     product .js JSON, so direct Add works even if that script is slow or absent.
     Never overwrites an existing resolved id; unavailable = left as-is. */
  function resolveCards() {
    var pal = palette(); if (!pal) return;
    var grid = document.querySelector('#ProductGridContainer'); if (!grid) return;
    var key = (pal.finish || '') + '|' + (pal.box || '');
    grid.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (resolvedId(card) || card.dataset.skFixResolvedKey === key) return;
      var a = card.querySelector('a[href*="/products/"]'); if (!a) return;
      var m = new URL(a.href, location.origin).pathname.match(/\/products\/([^/?#]+)/); if (!m) return;
      var handle = decodeURIComponent(m[1]); card.dataset.skFixResolvedKey = key;
      fetchProduct(handle).then(function (prod) {
        var v = resolveVariant(prod, pal); if (!v) return;
        card.dataset.skzVariantId = String(v.id);
        var btn = card.querySelector('.quick-add__submit');
        if (btn && !btn.disabled) setBtnLabel(btn, isCabinet(card) ? 'Add to Kitchen' : 'Add');
      }).catch(function () {});
    });
  }
  /* Pro workspace: Visual Shop grid first; explicit Pro choice stays on Pro. */
  function getMode() { try { if (sessionStorage.getItem('sk-workspace-choice') === 'pro') return 'pro'; return localStorage.getItem('skCatalogView') || 'visual'; } catch (e) { try { return localStorage.getItem('skCatalogView') || 'visual'; } catch (e2) { return 'visual'; } } }
  function setMode(m) { try { localStorage.setItem('skCatalogView', m); sessionStorage.setItem('sk-workspace-choice', m); } catch (e) {} }
  function proSection() { var el = document.querySelector('.skv-trade-order--catalog'); return el ? (el.closest('.shopify-section') || el) : null; }
  function gridSection() { var el = document.querySelector('#ProductGridContainer'); return el ? (el.closest('.shopify-section') || el) : null; }
  function entryBar() { return document.querySelector('[data-sk-pro-entry-bar]'); }
  function applyMode(mode, scrollToPro) {
    var pro = proSection(), grid = gridSection();
    if (!pro || !grid) return;
    var isPro = mode === 'pro';
    grid.style.display = isPro ? 'none' : '';
    pro.style.display = isPro ? '' : 'none';
    document.body.classList.toggle('sk-pro-mode', isPro);
    var bar = entryBar();
    if (bar) bar.querySelectorAll('[data-sk-pro-entry]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.skProEntry === mode)); });
    if (isPro && scrollToPro) pro.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function moveViewbar() {
    var bar = entryBar(); if (!bar) return;
    var vb = document.querySelector('.sk-vnext-viewbar');
    var slot = bar.querySelector('[data-sk-pro-entry-viewbar]');
    if (vb && slot && vb.parentNode !== slot) { slot.appendChild(vb); bar.classList.add('sk-pro-entry--has-viewbar'); }
  }
  function setupPro() {
    if (!document.querySelector('#ProductGridContainer')) return;
    var pro = proSection(), bar = entryBar();
    /* If the Pro section is genuinely absent, keep the entry bar visible and
       route its Pro button to the contractors quick-order page instead of
       hiding the only Pro entry point. */
    if (!pro) {
      if (bar) bar.querySelectorAll('[data-sk-pro-entry="pro"]').forEach(function (b) { b.addEventListener('click', function () { location.assign('/pages/contractors'); }, { once: true }); });
      return;
    }
    moveViewbar();
    var mode = getMode() === 'pro' ? 'pro' : 'visual';
    applyMode(mode, false);
    /* Reload in Pro mode must land on the Pro desk, not on a hidden grid. */
    if (mode === 'pro') setTimeout(function () { var p2 = proSection(); if (p2) p2.scrollIntoView({ behavior: 'auto', block: 'start' }); }, 150);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sk-view]');
    if (b) { setTimeout(function () { moveViewbar(); applyMode(getMode(), false); }, 60); return; }
    var f = e.target.closest && e.target.closest('[data-sk-pro-entry]');
    if (f) { var mode = f.dataset.skProEntry === 'pro' ? 'pro' : 'visual'; setMode(mode); applyMode(mode, mode === 'pro'); }
  });
  /* PDP label guard: restore Add to Kitchen if a variant change flips it to Add to cart. */
  function guardPdp() {
    document.querySelectorAll('main[data-template="product"] .product-form__submit').forEach(function (btn) {
      var span = btn.querySelector('span');
      if (!span) return;
      if (!span.dataset.skOriginalLabel) span.dataset.skOriginalLabel = span.textContent.trim();
      if (span.dataset.skOriginalLabel === 'Add to Kitchen' && span.textContent.trim() === 'Add to cart') span.textContent = 'Add to Kitchen';
    });
  }
  function boot() {
    scanCards(); resolveCards(); applyPdpPalette(); setupPro(); guardPdp();
    var root = document.querySelector('#ProductGridContainer') || document.body;
    if (window.MutationObserver) {
      /* Coalesce observer bursts: a synchronous scan on every mutation batch
         fed its own mutations back into the observer. Schedule at most one
         scan per 60ms tick; with the text guards above, a settled scan now
         makes no further mutations, so the loop terminates. */
      var skScanScheduled = false;
      new MutationObserver(function () {
        if (skScanScheduled) return;
        skScanScheduled = true;
        setTimeout(function () { skScanScheduled = false; scanCards(); moveViewbar(); guardPdp(); }, 60);
      }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: [ 'data-skz-variant-id', 'class'] });
    }
    document.addEventListener('sk:profile-change', function () { setTimeout(scanCards, 200); });
    setTimeout(function () { scanCards(); resolveCards(); }, 1500); setTimeout(function () { scanCards(); resolveCards(); setupPro(); }, 3500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('DOMContentLoaded', function () { setTimeout(function () { moveViewbar(); setupPro(); resolveCards(); }, 200); });
})();
